import { createActions } from 'reduxsauce';

export const { Creators, Types } = createActions({
  getProfileList: ['payload'],
  getProfileListStart: ['payload'],
  getProfileListSuccess: ['payload'],
  getProfileListFailure: ['payload'],

  setSearchQueries: ['payload']
});
